import $ from "jquery"
import DynamicModuleLoader from "./../../js/global/DynamicModuleLoader"

class FormComponent {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("FormComponent::initialize()")

		this._initializeFormItems()

		//some forms were lazy loaded, make sure that that all needed components are loaded
		$("body").on("bb-form-items-changed", () => {
			this._initializeFormItems()
		})

		$("body").on("submit", "form", (event) => {
			const form = $(event.target).closest("form")[0]
			let isValid = false

			if ($(document.activeElement).hasClass("previousPage")) {
				isValid = true
			} else {
				isValid = this._validate(form)
			}

			let customEvent = $.Event("onFormSubmit", { isValid: isValid })
			$(form).trigger(customEvent)

			if (!isValid) {
				event.preventDefault()
				form.classList.add("has-error")
			} else {
				form.classList.remove("has-error")

				if ($(form).data("ajaxuri")) {
					event.preventDefault()
					this._sendAjaxForm(form)
				}
			}
		})

		// special behavior for checkboxed to show/hide extra form elements
		$(document.body).on("change", ".mdc-checkbox input.invoiceAddress", (e) => {
			const $currentForm = $(e.target).closest("form")

			if ($(e.target).is(":checked")) {
				$currentForm.find(".form-group.invoiceAddress").slideUp()
			} else {
				$currentForm.find(".form-group.invoiceAddress").slideDown()
			}
		})
	}

	_initializeFormItems() {
		DynamicModuleLoader.load(
			$(".multiselect").length,
			DynamicModuleLoader.modules.multiselectComponent,
			(multiselectComponent) => {
				this.multiselect = multiselectComponent
			},
		)

		DynamicModuleLoader.load(
			$(".mdc-select").length,
			DynamicModuleLoader.modules.selectComponent,
			(selectComponent) => {
				this.select = selectComponent
			},
		)

		DynamicModuleLoader.load(
			$(".mdc-text-field").length,
			DynamicModuleLoader.modules.inputFieldComponent,
			(inputFieldComponent) => {
				this.input = inputFieldComponent
			},
		)

		DynamicModuleLoader.load(
			$(".mdc-checkbox").length,
			DynamicModuleLoader.modules.checkboxComponent,
			(checkboxComponent) => {
				this.checkbox = checkboxComponent
			},
		)

		DynamicModuleLoader.load(
			$(".mdc-radio").length,
			DynamicModuleLoader.modules.radiofieldComponent,
			(radiofieldComponent) => {
				this.radio = radiofieldComponent
			},
		)

		DynamicModuleLoader.load(
			$(".button-select-file").length,
			DynamicModuleLoader.modules.fileUploadComponent,
			(fileUploadComponent) => {
				this.fileUpload = fileUploadComponent
			},
		)

		DynamicModuleLoader.load(
			$(".bb-datepicker").length,
			DynamicModuleLoader.modules.datepickerComponent,
			(datepickerComponent) => {
				this.datepicker = datepickerComponent
			},
		)
	}

	_validate(form) {
		let isAllValid = true
		let firstErrorFounded = false

		form.querySelectorAll(
			"fieldset:not([data-repeatable-container]):not([data-repeatable-container] > fieldset)",
		).forEach((fieldset) => {
			if (fieldset.querySelector(".mdc-text-field")) {
				let isValid = true
				let input = fieldset.querySelector("input")
					? fieldset.querySelector("input")
					: fieldset.querySelector("textarea")

				if ($(input).is(":visible")) {
					if ($(fieldset).parent().hasClass("bb-datepicker") && !input.pattern) {
						isValid = this.datepicker.validate(input)
					} else {
						isValid = this.input.validate(input)
						if (input && input.getAttribute("type") === "password" && input.getAttribute("data-confirm")) {
							isValid = this.input.validatePasswordConfirm(input)
						}
					}
				}
				isAllValid = isAllValid ? isValid : isAllValid
			} else if (fieldset.querySelector(".mdc-select")) {
				let isValid = this.select.validate(fieldset.querySelector("input"))
				isAllValid = isAllValid ? isValid : isAllValid
			}
			if (fieldset.querySelector(".radio-holder")) {
				let isValid = this.radio.validate(fieldset)
				isAllValid = isAllValid ? isValid : isAllValid
			}
			if (fieldset.querySelector(".checkbox-holder")) {
				let isValid = this.checkbox.validate(fieldset)
				isAllValid = isAllValid ? isValid : isAllValid
			}
			if (fieldset.querySelector(".button-select-file")) {
				let isValid = this.fileUpload.validate(fieldset)
				isAllValid = isAllValid ? isValid : isAllValid
			}
			if (fieldset.querySelector(".multiselect--holder")) {
				let isValid = this.multiselect.validate(fieldset)
				isAllValid = isAllValid ? isValid : isAllValid
			}

			if (fieldset.classList.contains("error") && !firstErrorFounded) {
				firstErrorFounded = true
				this._scrollToFirstError(fieldset)
			}
		})

		return isAllValid
	}

	_scrollToFirstError(fieldset) {
		let scrollTo = $(fieldset).offset().top
		const $overlay = $(fieldset).parents(".bb-overlay")

		$(fieldset).find(":input:not([type=hidden])").focus()
		if ($overlay.length === 0) {
			scrollTo = scrollTo - ($(".bb-header").length ? $(".bb-header")[0].offsetHeight : 0)
			$("html, body").animate({ scrollTop: scrollTo + "px" }, 700)
		} else {
			// $overlay.find(".modal-content-container").animate({ scrollTop: scrollTo + "px" }, 700)
		}
	}

	_sendAjaxForm(form) {
		$(form).find(".form__submit").css("pointer-events", "none")
		$(form).find('button[type="submit"]').css("pointer-events", "none")

		const formData = new FormData(form)
		formData.append($(document.activeElement).attr("name"), $(document.activeElement).val())

		$.ajax({
			type: "POST",
			url: $(form).data("ajaxuri"),
			contentType: false,
			cache: false,
			processData: false,
			data: formData,
			success: (msg) => {
				const $formContainer = $(form).closest(".frame-type-form_formframework")
				//$formContainer.attr("role", "status") // Wird von NVDA nicht vorgelesen
				$formContainer.attr("aria-live", "polite")

				// replace tabs and line endings
				msg = msg.replace(/(\r\n|\n|\r|\t)/g, "")

				// check if response is "redirect" to show a new page on form success
				if (
					$(msg).length > 0 &&
					$(msg).hasClass("bb-form-message--redirect") &&
					$(msg).data("redirecturl") &&
					$(msg).data("redirecturl") !== ""
				) {
					location.href = $(msg).data("redirecturl")
				}
				// check if form has success message, if yes animate new content
				else if ($(msg).length > 0 && $(msg).hasClass("bb-form-message--success")) {
					$formContainer.animate({ opacity: 0 }, 250, () => {
						const oldHeight = $formContainer.height()
						$formContainer.html(msg)
						const newHeight = $formContainer.height()
						$formContainer.css("height", oldHeight + "px")

						$formContainer.animate(
							{
								opacity: 1,
								height: newHeight + "px",
							},
							350,
							() => {
								$formContainer.removeAttr("style")
							},
						)
					})
				} else {
					const redirectUrl = $(form).data("redirecturl")
					$formContainer.html(msg)

					if (redirectUrl && redirectUrl !== "") {
						$formContainer.find("form").attr("data-redirecturl", redirectUrl)
					}

					// reinit all form items
					$("body").trigger("bb-form-items-changed")

					// ReInit for form spam protection reload (Extension form_shield)
					window.document.dispatchEvent(
						new Event("DOMContentLoaded", {
							bubbles: true,
							cancelable: true,
						}),
					)
				}

				const scrollPos =
					$(".frame-type-form_formframework:visible").offset().top -
					20 -
					($("#bb-header").length ? $("#bb-header")[0].offsetHeight : 0)
				$("html, body")
					.stop()
					.animate({ scrollTop: scrollPos + "px" }, 700)
			},
			error: (xhr, status) => {
				// eslint-disable-next-line no-console
				console.log("error:", xhr, status)

				$(form).find(".form__submit").removeAttr("style")
				$(form).find('button[type="submit"]').removeAttr("style")
			},
		})
	}
}

export default FormComponent
